import './src/styles/index.scss';
import Provider from './provider'

export const wrapRootElement = Provider

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location && location.state) location.state.referrer = prevLocation ? prevLocation.pathname : null;
};

